<div #customBox class="custom-search-results-advise">
  <div class="container-row">
  <mat-icon>search</mat-icon>
  <div class="text-container">
    <p class="title">{{'no_search_performed' | transloco}}</p>
    <p>{{subtitle}}</p>
  </div>
  </div>
  <hr/>
</div>
